module.controller('loadSubCtrl', ['$scope', '$rootScope', '$state', '$stateParams', '$http', '$filter', 'baseURI', 'Transform', 'LimitsService', 'cacheService', 'Session', 'OVERLAY','scheduleRecurringService', 'accountService', function ($scope, $rootScope, $state, $stateParams, $http, $filter, baseURI, Transform, LimitsService, cacheService, Session, OVERLAY,scheduleRecurringService, accountService){
  var transferUrl = baseURI + 'card/transfer';
  var createRecurringUrl = baseURI + 'card/transfer/auto';

  $scope.overlay = OVERLAY['member.home.subcard/load'];
  $scope.balance = $rootScope.balance;
  $scope.amountValid = false;
  $scope.formData = {};
  $scope.alert = {};
  $scope.alert.alertMessage = 'Sorry, we were unable to process the transfer at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';
  $scope.limits = Session.getLimits()['CRD-TRN-IN'];
  $scope.amountValid = false;
  $scope.amountMessage = null;
  $scope.balance = $rootScope.balance;

  $scope.transferFrom = {};

  // get accounts from account service
  accountService.initializeAccounts(function(err, accounts){
    if(!err){
      // get the selected account
      var account = accountService.getAccount($stateParams.username);

      // The subcard we are sending to
      $scope.transferFrom = {
        Username: account.username,
        FirstName: account.title.split(' ')[0],
        LastName: account.title.split(' ')[1],
        Balance: account.balance
      };
    }
  });

  // first option in checkbox
  var sourceCard = {
    Name: 'Your ' + $scope.brand.commonProgramName,
    Id: 0
  };

  // Adds context to the amount messaging
  $scope.formatAmountMessage = function(){
    if(!$scope.formData.Source){
      return null;
    }
    var amount = $scope.formData.Amount;
    var volumeLimit = ($scope.limits && $scope.limits.volume) || null;
    var sourceId = $scope.formData.Source.Id;

    if(amount){
      if (amount > $scope.balance && sourceId === 0){
        $scope.amountValid = false;
        $scope.amountMessage = 'Oops, there\'s not enough on your ' + $scope.brand.commonProgramName + '. Send from a bank.';
      }
      else if (amount <= 0){
        $scope.amountValid = false;
        $scope.amountMessage = 'Oops, you need to enter a positive amount to transfer.';
      }
      else if (volumeLimit && amount > volumeLimit){
        $scope.amountValid = false;
        $scope.amountMessage = 'Oops, looks like the current limit today is ' + $filter('akimboCurrency')(volumeLimit, '$') + '.';
      }
      else {
        $scope.amountValid = true;
        $scope.amountMessage = 'ok';
      }
    } else {
      $scope.amountValid = false;
      $scope.amountMessage = null;
    }
  };

  $scope.$watch('formData.Source', $scope.formatAmountMessage);

  // watch makeRecurring value;
  // if this is the first time a ch updates it, show the calendar
  $scope.$watch('formData.makeRecurring', function(newValue, oldValue){
    if(newValue == 'on' && oldValue === undefined){
      $scope.formData.showScheduleOption = true;
    }
  });

  // Validation for step1
  $scope.attemptSubmission = function (formData){
    if(formData.$valid && $scope.amountValid){
      $scope.alert.errorShown = false;
      $state.go('member.home.subaccount/load.step2', $scope.transferFrom);
    } else {
      $scope.alert.errorShown = true;
      $scope.attempted = true;
    }
  };

  // Review and submit
  $scope.processForm = function(formData){
    $scope.loading = true;

    // does this need to be sent now or is this a make recurring
    if($scope.formData.makeRecurring == 'on' && $scope.formData.datePicker.dateSelect.formattedDate != 'Today'){
      scheduleRecurringTransaction(function(err, data){
        $scope.loading = false;
        if(err){

        } else {
          // Update the feature limits
          LimitsService.update();

          $state.go('member.home.subaccount/load.step3', $scope.transferFrom);
          $scope.title = 'Your auto send is set up!';
          $scope.info = 'Your auto send with begin on ' + $scope.formData.datePicker.dateSelect.label;
          $scope.alert.successShown = true;
          $scope.alert.successMessage = 'You\'ve set a recurring transfer to ' + ($scope.transferFrom.Username || $scope.transferTo.Email || $scope.transferTo.FirstName) + ' for ' + $filter('akimboCurrency')($scope.formData.Amount, '$');
        }
      });
    } else {
      sendSingleTransaction();
    }
  };

  var sendSingleTransaction = function(){
    var request = {
      ToType: 'akimbo',
      Amount: $scope.formData.Amount,
      ToUsername: $scope.transferFrom.Username,
      FromBankAccountId: $scope.formData.Source.Id || 0
    };


    $http({
      method: 'POST',
      url: transferUrl,
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
      },
      data: Transform.encode(request)
    }).then(function(resp){
      var data = resp.data;

      $scope.loading = false;
      if(data.Success){
        // Clear the balance and feed cache
        cacheService.clear('transfer');

        // Update the feature limits
        LimitsService.update();

        // check if this is a recurring transfer
        if($scope.formData.makeRecurring == 'on')
          scheduleRecurringTransaction();

        $scope.title = 'Your money has been sent!';
        $scope.info = 'Now wasn\'t that easy?';
        $state.go('member.home.subaccount/load.step3', $scope.transferFrom);
        $scope.alert.successShown = true;
        $scope.alert.successMessage = 'You\'ve sent ' + $filter('akimboCurrency')($scope.formData.Amount, '$') + ' to ' + $scope.transferFrom.Username;
      } else {
        $scope.alert.alertShown = true;
      }
    }).catch(function (error){
      $scope.loading = false;
      $scope.alert.alertShown = true;
    });


  };

  // get CH banks
  var getBanks = function (){
    $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
      $scope.sources = resp.data.Data || [];
      $scope.sources.unshift(sourceCard);
      $scope.formData.Source = sourceCard;
    }).catch(function(){
      $scope.sources = [];
      $scope.sources.unshift(sourceCard);
      $scope.formData.Source = sourceCard;
    });
  };

  // Schedules a recurring card transfer
  // called after a successful card transfer with a recurring toggle on
  var scheduleRecurringTransaction = function(cb){
    var startDate = ($scope.formData.datePicker.dateSelect.formattedDate == 'Today' ?
                     $scope.formData.dateOptions[1].formattedDate :
                     $scope.formData.datePicker.dateSelect.formattedDate);

    var scheduleRequest = {
	    FromBankAccountId: $scope.formData.Source.Id || 0,
	    ToUsername: $scope.transferFrom.Username,
	    Amount: $scope.formData.Amount,
	    StartDate: startDate,
	    FrequencyType: $scope.formData.datePicker.frequency.key,
	    FrequencyDay1: $scope.formData.datePicker.day1.key,
	    FrequencyDay2: $scope.formData.datePicker.day2.key,
	    TransferContinuity: 'C'
    };

    scheduleRecurringService.set({url: createRecurringUrl}, scheduleRequest)
      .then(function(data){
        if(cb)
          cb(null, data);
      }).catch(function(err){
        if(cb)
          cb(err);
      });

  };

  getBanks();

}]);
